<template>
	<div id="contact_us" >
		<div class="contact_us">
			<div class="contact_us_content container">
				<SectionHeader
				topText=""
				bottomText="FAQ"
				/>
				<FAQ />
				<!-- <div class="inner-container">

					<div class="header">
						<h3>do you have a question?</h3>
					</div>
					<div class="additional_content">
						<p>Follow the links below for more detailed information or contact your representative!</p>
						<div class="quick_links">
							<h4>Quick Access Links</h4>
							<div class="btn_links">
								<a href="https://www.mlb.com/cubs/tickets/season-tickets/holders/payment-information" class="payment-link" target="_blank">Payment Options</a>
								<div class="col-two">
									<a href="https://www.mlb.com/cubs/tickets/season-tickets/holders/faq/2023"   target="_blank">FAQ</a>
									<a href="https://www.mlb.com/cubs/tickets/season-tickets/holders/benefits/2023" target="_blank">F&#38;B Discount</a>

								</div>
								<div class="col-two">
									<a href="https://www.mlb.com/cubs/tickets/season-tickets/holders/benefits/2023" target="_blank">Ticket Exchange/Credit</a>
									<a href="https://www.mlb.com/cubs/tickets/season-tickets/holders/benefits/2023" target="_blank">Merchandise Discount</a>
								</div>
							</div>
						</div>
					</div>
				</div> -->


			</div>

		</div>
		<divider img_src="divider-5.png" />
	</div>
</template>


<script>
import SectionHeader from "@/components/SectionHeader";
import divider from "@/components/divider";
import FAQ from "./FAQ";
import { reactive, toRefs, computed } from "vue";
import { useStore } from "vuex";
import VueScrollTo from "vue-scrollto";

export default {
	components: { SectionHeader, divider, FAQ },
	setup() {
		const store = useStore();
		// State
		const state = reactive({
			repInfo: computed(() => store.getters["purl/getAccountRep"]),
		});
		function toTop() {
			VueScrollTo.scrollTo("#hero");
		}
		function getRepAvatar() {
			// if (!state.repInfo?.name) return require("@/assets/images/avatar.jpeg");

			// switch (state.repInfo?.name) {
			//   case "John Doe":
			//     return require("@/assets/images/avatar.jpeg");
			//
			//   case "Alieh Shaban":
			//     return require("@/assets/images/reps/Alieh-Shaban.jpg");
			//
			//   case "Corina Hewitt":
			//     return require("@/assets/images/reps/Corina-Hewitt.jpg");
			//
			//   case "Emma Hryzan":
			//     return require("@/assets/images/reps/Emma-Hryzan.jpg");
			//
			//   case "Franesa Brown":
			//     return require("@/assets/images/reps/Franesa-Brown.jpg");
			//
			//   case "Joshua Madarang":
			//     return require("@/assets/images/reps/Josh-Madarang.jpg");
			//
			//   case "Kalle Cooper":
			//     return require("@/assets/images/reps/Kalle-Cooper.jpg");
			//
			//   case "Paul Squires":
			//     return require("@/assets/images/reps/Paul-Squires.jpg");
			//
			//   case "Robert Jackson":
			//     return require("@/assets/images/reps/Robert-Jackson.jpg");
			//
			//   case "Sophia Lautieri":
			//     return require("@/assets/images/reps/Sophia-Lautieri.jpg");
			//
			//   case "Veronica Dinger":
			//     return require("@/assets/images/reps/Veronica-Dinger.jpg");
			//
			//   default:
			//     return require("@/assets/images/avatar.jpeg");
			// }
		}
		return { ...toRefs(state), toTop, getRepAvatar };
	},
};
</script>

<style lang="scss" scoped>
.contact_us {
	// background-color: theme-var($--ch-theme-background-secondary);
	background-image: url("~images/bgImage.jpg");
	background-size: cover;
	background-position: left bottom;
	@include media-breakpoint-down(sm) {
		background-image: url("~images/bgImage_mobile.jpg");
		// background-size:cover;
	}
	// background-size: cover;

	&_content {
		display: flex;
		flex-direction: column;
		// align-items: center;
		align-items: flex-start;
		padding:0px;
		gap: 50px;
		z-index: 1;
		padding: 150px 100px 100px 120px;
		@include media-breakpoint-down(sm) {
			    padding: 150px 30px 100px 30px;
		}
		@include media-breakpoint-only(md) {
			padding: 150px 30px 100px 30px;
		  }
		  @media only screen and (min-width: 1023px) and (max-width: 1025px) and (-webkit-min-device-pixel-ratio: 1.5) {
 			 padding: 150px 70px 100px 70px;
 		 }
		.inner-container{
			margin: 0 auto;
		}
		h3{
			font-family: 'Verlag Condensed Book';
			font-style: normal;
			font-weight: 400;
			font-size: 25px;
			line-height: 100%;
			text-align:center;
			text-transform: uppercase;
			margin-bottom:0px;
			color: #FFFFFF;
		}
		h4{
			font-family: 'Verlag Condensed Book';
			font-style: normal;
			font-weight: 400;
			font-size: 20px;
			line-height: 100%;
			text-align:center;
			text-transform: uppercase;
			color: #0E3386
		}
		.header{
			display: flex;
			flex-direction: column;
			justify-content: center;
			align-items: center;

			padding: 15px 10px;
			gap: 10px;
			// width: 800px;
			// height: 55px;
			background: #0E3386;

		}
		// .additional_content{
		// 	display: flex;
		// 	flex-direction: column;
		// 	justify-content: center;
		// 	align-items: center;
		// 	margin: 0 10px;
		// 	padding: 15px 30px 50px;
		// 	gap: 30px;
		// 	box-shadow: 0px 8px 15px rgba(0, 0, 0, 0.2);
		// 	// width: 780px;
		// 	background: #FFFFFF;
		// 	@include media-breakpoint-down(sm) {
		//
		// 	  padding: 15px 0px 50px;
		//    }
		//
   		// @include media-breakpoint-only(md) {
   		//    padding: 15px 0px 50px;
   		// }
		//  @media only screen and (min-width: 1023px) and (max-width: 1025px) and (-webkit-min-device-pixel-ratio: 1.5) {
		//
		//  }
		// 	p{
		// 		font-family: 'Verlag Book';
		// 		font-style: normal;
		// 		font-weight: 325;
		// 		font-size: 16px;
		// 		line-height: 145%;
		// 		/* or 23px */
		// 		padding-top:20px;
		// 		text-align: center;
		//
		// 		/* black */
		//
		// 		color: #474747;
		// 	}
		// 	.payment-link{
		//
		// 		display: flex;
		// 		flex-direction: row;
		// 		justify-content: center;
		// 		align-items: center;
		// 		margin: 10px auto;
		// 	}
		// }

		// .btn_links{
		// 	padding-top:20px;
		// 	a{
		// 		padding: 8px 40px;
		// 		width:280px;
		// 		text-decoration:none;
		// 		color:white;
		// 		background: #0B2255;
		// 		border-radius: 55px;
		// 		font-family: 'Verlag Light';
		// 		font-style: normal;
		// 		font-weight: 325;
		// 		font-size: 20px;
		// 		line-height: 24px;
		// 		margin: 10px;
		// 		transition: all 0.3s ease 0s;
		// 		&:hover{
		// 			background: #CC3433;
		// 			transform: translateY(2px);
		// 		}
		//
		// 	}
		// 	.col-two{
		// 		display: flex;
		// 		align-items:center;
		// 		justify-content:space-between;
		// 		@include media-breakpoint-down(sm) {
		// 			flex-direction:column;
		// 		}
		// 		a{
		// 			display: flex;
		// 			justify-content: center;
		// 			align-items: center;
		// 		}
		//
		// 	}
		// }
	}
	.to_top {
		position: absolute;
		width: 50px;
		height: 50px;
		right: 100px;
		border-radius: 50%;
		bottom: 100px;
		background: theme-var($--ch-theme-highlight);
		text-transform: uppercase;
		color: white;
		display: flex;
		justify-content: center;
		align-items: center;
		cursor: pointer;
		text-align: center;
		svg {
			fill: theme-var($--ch-theme-on-secondary);
			width: 30px;
		}
	}
}
</style>
